import { createVerticalFlowAnalytics } from "@/components/ClustersPage/VerticalFlowComponents/analytics";
import { ClusterType } from "@/types";
import { trackEvent } from "@/utils/analytics";
import { AnalyticsEventType } from "@/constants/analytics";

const baseAnalytics = createVerticalFlowAnalytics(ClusterType.CONTAINER);

export const containerVerticalFlowAnalytics = {
  ...baseAnalytics,
  trackRecipesFirstOptOut: () => {
    trackEvent(AnalyticsEventType.RECIPE_FIRST_OPT_OUT_CLICKED);
  },
  /** Recipe chosen on the recipes-first step only (not deployment RecipesSection). */
  trackRecipesFirstRecipeSelected: (payload: { recipe: string }) => {
    trackEvent(AnalyticsEventType.RECIPES_FIRST_RECIPE_SELECTED, {
      ...payload,
      clusterType: ClusterType.CONTAINER,
      step: "recipes_first"
    });
  },
  trackContainerImageSelected: (imageType: "public" | "private") => {
    trackEvent(AnalyticsEventType.CLUSTER_IMAGE_SELECTED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      image: imageType
    });
  },
  trackEnvVarAdded: (type: "normal" | "private") => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "environment_variables",
      action: "add",
      variableType: type
    });
  },
  trackEnvVarRemoved: (type: "normal" | "private") => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "environment_variables",
      action: "remove",
      variableType: type
    });
  },
  trackContainerNameFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "customize",
      field: "container_name"
    });
  },
  trackStartCommandFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "start_command"
    });
  },
  trackPortFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "port"
    });
  },
  trackRecipeModalOpened: () => {
    trackEvent(AnalyticsEventType.TAB_OPENED, {
      clusterType: ClusterType.CONTAINER,
      tab: "recipes_modal"
    });
  },
  trackContainerImageFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "container_image"
    });
  },
  trackPrivateRegistryUsernameFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "private_registry_username"
    });
  },
  trackPrivateRegistryPasswordFilled: () => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "private_registry_password"
    });
  },
  trackEnvVarKeyFilled: (type: "normal" | "private") => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "environment_variable_key",
      variableType: type
    });
  },
  trackEnvVarValueFilled: (type: "normal" | "private") => {
    trackEvent(AnalyticsEventType.FORM_FILLED, {
      clusterType: ClusterType.CONTAINER,
      step: "deployment",
      field: "environment_variable_value",
      variableType: type
    });
  },
  trackHardwareWarningAcknowledged: () => {
    trackEvent(AnalyticsEventType.COMPONENT_CLICKED, {
      clusterType: ClusterType.CONTAINER,
      component: "hardware_warning_dialog",
      action: "acknowledge"
    });
  }
};
